export default [{
    icon: ['left', 'fal', 'coin'],
    text: 'Less than $15,000',
    color: 'lime',
    value: '<15000'
},
{
    icon: ['left', 'fal', 'coins'],
    text: '$15,000 - $30,000',
    color: 'yellow',
    value: '15000-30000'
},
{
    icon: ['left', 'fal', 'money-bill-wave'],
    text: '$30,000 - $50,000',
    color: 'blueish',
    value: '30000-50000'
},
{
    icon: ['left', 'fal', 'sack-dollar'],
    text: 'More than $50,000',
    color: 'green',
    value: '>50000'
}];